// サポートからの知らせ（コメント・いいね・リアクション・処分）に付く、
// そのピースの詳細をひらくボタン。文章だけだと どれのことか わからないため。

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { Course } from "features/courses/types";
import { actions as courseActions } from "features/course/slice";
import { actions as builderActions } from "features/builder/slice";

export const OpenPieceButton = ({ pieceId, tab }: { pieceId: string; tab?: string }) => {
  const play = usePlaySound();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = () => {
    play();
    btnDelay(() => {
      dispatch(courseActions.updateSelectedCourse({ course: Course.PIECE_BUILDER }));
      // スタート画面で止めず、そのままピースの一覧（＝詳細を開く先）まで進める。
      // 一覧から もどる と、ゲーム機の中のカード選択に戻る
      dispatch(courseActions.updateShowCourseTop(false));
      dispatch(courseActions.updateShowCourseList(true));
      dispatch(builderActions.requestPieceDetail({ pieceId, tab }));
      navigate("/courses/builder");
    });
  };

  return (
    <div className="flex-row-el items-center w-full mt-2 upsilon">
      <button type="button" onClick={handleClick} className="type-inherit-font btn btn-primary">
        <div className="flex-row-center gap-1">
          <span className="material-symbols-outlined text-white type-md">extension</span>
          <p className="type-text type-body text-white whitespace-nowrap">
            {I18n.t("MSG_BUILDER_OPEN_PIECE_BTN")}
          </p>
        </div>
      </button>
    </div>
  );
};
